export const userRoles = {
    SUPERADMIN: "superadmin",
    ADMIN: "admin",
    USER: "user",
    OWNER: "owner"
};

export const shareAccessLevels = {
    SELF: "self",
    FACILITY: "facility",
    GLOBAL: "global",
    USERS: "users",
};

export const shareAccessLabels = {
    [shareAccessLevels.SELF]: "Only me",
    [shareAccessLevels.FACILITY]: "Facility",
    [shareAccessLevels.GLOBAL]: "Global",
    [shareAccessLevels.USERS]: "Specific Users",
};

export const MAX_PROMPT_LENGTH =
  Number(process.env.REACT_APP_MAX_PROMPT_LENGTH) || 10000;
export const MIN_PROMPT_LENGTH = Number(process.env.REACT_APP_MIN_PROMPT_LENGTH) || 100;

export const MIN_PROMPT_DESCRIPTION_LENGTH =
  Number(process.env.REACT_APP_MIN_PROMPT_DESCRIPTION_LENGTH) || 50;

export const AUTO_LOGOFF_POPUP_COUNTDOWN =
  Number(process.env.REACT_APP_AUTO_LOGOFF_POPUP_COUNTDOWN) || 2 * 60; // in seconds


export const MIN_ASSISTANT_INSTRUCTIONS_LENGTH = 100;
export const MAX_ASSISTANT_INSTRUCTIONS_LENGTH = 10000;

export const MAX_FILE_UPLOAD_PER_QUERY = 10;
export const MAX_TOTAL_FILE_UPLOAD_SIZE_PER_QUERY = Number(process.env.REACT_APP_MAX_TOTAL_ASSISTANT_FILE_UPLOAD_SIZE_PER_QUERY) || 50; // in MB
export const MAX_TOTAL_FILE_UPLOAD_IN_ASSISTANT = 100; // Max number of files (existing + new) allowed per assistant

export const singleSelectStyles = {
  container: (base) => ({
    ...base,
    width: "100%",
    fontSize: "14px",
  }),

  control: (base, state) => ({
    ...base,
    minWidth: "100%",
    width: "100%",
    borderRadius: "12px",
    backgroundColor: "#f9fafb",
    color: "var(--select-text)",
    borderColor: state.isFocused
      ? "#3b82f6" // blue-500
      : "var(--select-border)",
    outline: "none",
    boxShadow: state.isFocused
      ? "0 0 0 2px rgba(59,130,246,0.35)"
      : "none",
    transition: "all 0.15s ease",
    "&:hover": {
      borderColor: "#3b82f6",
    },
  }),

  valueContainer: (base) => ({
    ...base,
    flexWrap: "nowrap",
  }),

  singleValue: (base) => ({
    ...base,
    color: "var(--select-text)",
  }),

  placeholder: (base) => ({
    ...base,
    color: "var(--select-placeholder)",
  }),

  input: (base) => ({
    ...base,
    minWidth: "2px",
    color: "var(--select-text)",
  }),

  menu: (base) => ({
    ...base,
    minWidth: "100%",
    backgroundColor: "#f9fafb",
    borderRadius: "12px",
    border: "1px solid var(--select-border)",
    boxShadow: "0 12px 30px rgba(0,0,0,0.25)",
    overflow: "hidden",
  }),

  menuList: (base) => ({
    ...base,
    padding: "6px",
  }),

  option: (base, state) => ({
    ...base,
    backgroundColor: state.isSelected
      ? "#3b82f6"
      : state.isFocused
      ? "var(--select-hover)"
      : "transparent",
    color: state.isSelected ? "#ffffff" : "var(--select-text)",
    borderRadius: "8px",
    cursor: "pointer",
    padding: "8px 10px",
    transition: "background 0.15s ease",
  }),

  indicatorSeparator: () => ({
    display: "none",
  }),

  dropdownIndicator: (base, state) => ({
    ...base,
    color: "var(--select-placeholder)",
    transition: "transform 0.2s ease",
    transform: state.selectProps.menuIsOpen
      ? "rotate(180deg)"
      : "rotate(0deg)",
    "&:hover": {
      color: "var(--select-text)",
    },
  }),

  menuPortal: (base) => ({
    ...base,
    zIndex: 9999,
  }),
};

